import { ComponentRef } from '@angular/core';
import { TemplateContext } from '../../../../models/reportTemplate.model';
import { EditorPropertySchema, EditorRenderStrategy, WidgetPropertyType, parseAttribute } from '../../sample-widgets/widget-config.helpers';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';
import { SegProfileContext } from '../seg-profile/seg-widget-config.shared';
import { SegTasksWidgetComponent } from './seg-tasks-widget.component';

export enum SegTasksWidgetAttr {
    ShowGroupHeadings = 'showGroupHeadings'
}

export function configureSegTasksWidget(
    componentRef: ComponentRef<unknown>,
    context: TemplateContext,
    sourceElement?: HTMLElement
): void {
    const component = componentRef.instance as SegTasksWidgetComponent;
    const ctx = context as SegProfileContext;
    component.profiles = ctx.computedData?.segProfiles ?? null;
    component.showGroupHeadings = parseAttribute(sourceElement?.getAttribute(SegTasksWidgetAttr.ShowGroupHeadings), true);
}

// NOTE ON KNOBS IN THE PDF: the `showGroupHeadings` knob drives the interactive Angular preview via
// configureSegTasksWidget above. The static PDF loop template cannot read per-widget attributes (they
// are stripped when the widget element is replaced by this string), so — matching the header-widget
// precedent — the loop template always renders the group headings.
// Built as a single template literal (not array.join) so no dynamic string is ever
// concatenated to form HTML — every fragment is a compile-time constant. This also
// silences the CodeGuru `join`-manipulates-HTML XSS false positive.
export const segTasksLoopTemplate = `[[#each computedData.segProfiles]]
<div style="${SEG_STYLES.section}">
<div style="${SEG_STYLES.subHeading}">[[this.segName]] — Tasks</div>
<div data-tpl-each="this.taskGroups">
<div style="${SEG_STYLES.tag}"><strong>[[this.groupName]]</strong></div>
<ul>
<li data-tpl-each="this.tasks" style="${SEG_STYLES.tag}">[[this]]</li>
</ul>
</div>
</div>
[[/each]]`;

export const segTasksLoopScopes: { loopExpr: string; label: string; fields: string[] }[] = [
    { loopExpr: 'computedData.segProfiles', label: 'Per SEG', fields: ['segName'] },
    { loopExpr: 'this.taskGroups', label: 'Per Task Group', fields: ['groupName'] },
    { loopExpr: 'this.tasks', label: 'Per Task', fields: [] }
];

export const segTasksEditorPropertySchema: EditorPropertySchema = {
    renderStrategy: EditorRenderStrategy.ReadOnly,
    propertySchema: [
        { key: SegTasksWidgetAttr.ShowGroupHeadings, label: 'Show Group Headings', type: WidgetPropertyType.Boolean }
    ]
};
